module.exports = require("@splunk/themes/SplunkThemeProvider");